import { api } from 'common';

import { DocumentSearchFormFields } from './FormFields';
import { documentSearchDocumentationMarkdown } from './documentation';
import { getDefaultDocumentSearchConfig } from './utils';
import { type BlockConfigProps } from '../../types';

export const documentSearchNodeConfig: BlockConfigProps<
  api.FlowDefinition.DocumentSearchBlock['config']
> = {
  defaultLabelPrefix: 'documentSearch',
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultConfig: getDefaultDocumentSearchConfig(),
  configFields: {
    schema: api.FlowDefinition.DocumentSearchBlockConfigSchema,
    FormFields: DocumentSearchFormFields,
  },
  documentationMarkdown: documentSearchDocumentationMarkdown,
};
